import { getVendorContent } from '@studio/design-system/themes/vendor.js';

export const VENDOR_SUPPORT_URLS = {
  iris: 'https://intercom.help/iris-ai/en',
  ptzoptics: 'mailto:support@ptzoptics.com'
} as const;

export const getVendorSupportURL = (): string => getVendorContent(VENDOR_SUPPORT_URLS);

// Opens the vendor support URL. Uses location.href for mailto: links to avoid
// the blank browser tab that window.open leaves behind with mailto: URLs.
export const openVendorSupport = (): void => {
  const url = getVendorSupportURL();

  if (url.startsWith('mailto:')) {
    window.location.href = url;
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

export const INVITE_ERROR_CODES = {
  LEGACY_BAD_REQUEST: 400,
  SESSION_INVALID: 401,
  ACCESS_DENIED: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
  ALREADY_REDEEMED: 4011,
  INVALID_TOKEN: 4012,
  WRONG_USER_ID: 4013,
  WRONG_EMAIL: 4014,
  HIGHER_ROLE: 4015,
  EXPIRED: 4016
} as const;

export const LEGACY_INVITE_ERROR_KEYWORDS = {
  INVALID: 'invalid',
  REDEEMED: 'redeemed'
} as const;

export const EXPIRED_INVITE_ERROR_CODES: ReadonlySet<number> = new Set([
  INVITE_ERROR_CODES.INVALID_TOKEN,
  INVITE_ERROR_CODES.EXPIRED
]);
